function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcDone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2386"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3845",
    d: "M16.5 0A16.5 16.5 0 1 1 0 16.5 16.5 16.5 0 0 1 16.5 0z",
    style: {
      fill: "#fd0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3846",
    d: "m10738.676 379.109 4.606 3.453 6.884-10.543",
    transform: "translate(-10729 -360.52)",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcDone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-done.506cbd3e05f36afb0187212c12c9352f.svg";